<tam-dialog tid="append-entities-dialog" class="append-entities-dialog" [opened]="opened" #dialogRef>
    <ng-template #title>
        <span class="dialog-title">Append entity(s)</span>
        <smart-icon class="dialog-close dark" name="close" (click)="clickClose()"></smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="notes-selected body-1">{{threadListTotalCount}} note(s) are selected.</div>
        <div class="entities-append">Please select entity(s) to append&nbsp;<span class="required-field">*</span></div>
        <div class="entity-list">
            <multi-entity-dropdown [config]="entityConfig" [valueChangeSubject]="widgetSubject">
            </multi-entity-dropdown>
        </div>
        <div class="tam-form-help" *ngIf="showRequiredField">
            {{'general.required_error_message' | stringLiterals}}
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="footer-container">
            <div class="button-container">
                <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button dialog-cancel"
                    (click)="onBackClick($event)">Go Back</button>
                <button tam-button tamType="primary" tamSize="normal" class="dialog-button dialog-publish"
                    (click)="onAppend()" [tamLoading]="publishButtonHasBeenClicked">Append</button>
            </div>
        </div>
    </ng-template>
</tam-dialog>